import React from 'react';
import { Page } from 'react-pdf';
import classNames from 'classnames';
import { PDFDocument } from 'Components/PDFDocument';

interface InteractMobileNavigationProps {
  documents: string[];
  pages: Record<string, number[]>;
  isLoaded: boolean;
  currentAbsolutePage: number;
  onNavigate: (documentFileIdx: number, pageNumber: number) => void;
}

const PREVIEW_WIDTH = 54;
const PREVIEW_HEIGHT = 76;

const previewStyle = { width: PREVIEW_WIDTH, height: PREVIEW_HEIGHT } as const;

const InteractMobileNavigation = ({
  documents,
  pages,
  isLoaded,
  currentAbsolutePage,
  onNavigate,
}: InteractMobileNavigationProps) => {
  let pdfDocumentFilesCount = 0;

  return (
    <div className="interactModal__mobileNavigation-scroll" role="list">
      {documents.map((pdfDocumentFile, pdfDocumentFileIdx) => (
        <PDFDocument file={pdfDocumentFile} key={pdfDocumentFile}>
          {isLoaded &&
            pages[pdfDocumentFile].map(pageNumber => {
              const absoluteIndex = ++pdfDocumentFilesCount;
              const isActive = absoluteIndex === currentAbsolutePage;
              return (
                <button
                  key={`${pdfDocumentFileIdx}-${pageNumber}`}
                  type="button"
                  className={classNames('interactModal__mobileNavigation-item', {
                    'interactModal__mobileNavigation-item--active': isActive,
                  })}
                  onClick={() => onNavigate(pdfDocumentFileIdx, pageNumber)}
                >
                  <div
                    className="interactModal__mobileNavigation-preview"
                    style={previewStyle}
                  >
                    <Page
                      pageNumber={pageNumber}
                      width={PREVIEW_WIDTH}
                      renderAnnotationLayer={false}
                      renderTextLayer={false}
                    />
                  </div>
                </button>
              );
            })}
        </PDFDocument>
      ))}
    </div>
  );
};

export default InteractMobileNavigation;
